import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DeletingAction = 'remove' | 'soft' | 'permanent' | null;

interface DeleteDialogState {
  open: boolean;
  itemsToDelete: string[];
  foldersToDelete: string[];
  deletingAction: DeletingAction;
}

const initialState: DeleteDialogState = {
  open: false,
  itemsToDelete: [],
  foldersToDelete: [],
  deletingAction: null,
};

const deleteDialogSlice = createSlice({
  name: 'deleteDialog',
  initialState,
  reducers: {
    openDeleteDialog: (state, action: PayloadAction<{ itemIds?: string[]; folderIds?: string[] }>) => {
      state.open = true;
      state.itemsToDelete = action.payload.itemIds || [];
      state.foldersToDelete = action.payload.folderIds || [];
      state.deletingAction = null;
    },
    setDeleteDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setItemsToDelete: (state, action: PayloadAction<string[]>) => {
      state.itemsToDelete = action.payload;
    },
    setFoldersToDelete: (state, action: PayloadAction<string[]>) => {
      state.foldersToDelete = action.payload;
    },
    setDeletingAction: (state, action: PayloadAction<DeletingAction>) => {
      state.deletingAction = action.payload;
    },
    resetDeleteDialog: (state) => {
      state.open = false;
      state.itemsToDelete = [];
      state.foldersToDelete = [];
      state.deletingAction = null;
    },
    cancelDelete: (state) => {
      state.open = false;
      state.itemsToDelete = [];
      state.foldersToDelete = [];
    },
  },
});

export const {
  openDeleteDialog,
  setDeleteDialogOpen,
  setItemsToDelete,
  setFoldersToDelete,
  setDeletingAction,
  resetDeleteDialog,
  cancelDelete,
} = deleteDialogSlice.actions;

export default deleteDialogSlice.reducer;
